import React, { Component } from 'react'
import './App.css'


import video from './images/cover.mp4'
import coverImage from './images/cover.jpg'
import coverMobile from './images/coverimg.jpg'
import title from './images/title_desk.svg'
import title_mobile from './images/title_mobile.svg'

let Header = () =>
	<header className="codrops-header">
		<video autoPlay loop poster={coverImage} id="covervid">
			<source src="" type="video/webm"/>
			<source src={video} type="video/mp4"/>
		</video>
		<img id="coverimage" src={coverMobile} />
		<div className="title"><img src={title} alt=""/></div>
		<div className="title_mobile"><img src={title_mobile} alt=""/></div>
		<div className="meta">
		<div className="byline">端傳媒</div>
		<div className="pubdate">2016-08-25</div>
		</div>
	</header>

export default Header


/** WEBPACK FOOTER **
 ** ./src/Header.js
 **/